
const Layout = () => import('./layouts/Index.vue')

const routes: any[] = [
    {
      path: '/',
      name: 'home',
      component: Layout,
      children: [],
      meta: {
        hidden: true
      }
    },
    {
      path: '/application',
      name: 'application',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import('@/views/application/list.vue'),
          name: '应用管理',
          meta: { title: '应用管理' }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/task',
      name: 'task',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import('@/views/task/list.vue'),
          name: '任务管理',
          meta: { title: '任务管理' }
        },
        {
          path: 'create',
          component: () => import('@/views/task/create.vue'),
          name: '创建任务',
          meta: { title: '创建任务', hidden: true }
        },
        {
            path: 'schedule',
            component: () => import('@/views/task/schedule.vue'),
            name: '计划任务',
            meta: { title: '计划任务', hidden: false }
          },
        {
          path: 'reportdetail/:id',
          component: () => import('@/views/task/reportDetail.vue'),
          name: '报告详情',
          meta: { title: '报告详情', hidden: true }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/script',
      name: 'script',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import('@/views/script/list.vue'),
          name: '脚本管理',
          meta: { title: '脚本管理' }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/datasource',
      name: 'datasource',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import('@/views/datasource/list.vue'),
          name: '数据源管理',
          meta: { title: '数据源管理' }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/device',
      name: 'device',
      component: Layout,
      children: [
        {
          path: 'list',
          component: () => import('@/views/device/list.vue'),
          name: '设备管理',
          meta: { title: '设备管理' }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/tag',
      name: 'tag',
      component: Layout,
      children: [
        {
          path: 'list',
          component: () => import('@/views/tag/list.vue'),
          name: '标签管理',
          meta: { title: '标签管理' }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/user',
      name: 'user',
      component: Layout,
      children: [
        {
          path: 'list',
          component: () => import('@/views/user/list.vue'),
          name: '用户管理',
          meta: { title: '用户管理' }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/home',
      name: 'home',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import('@/views/home/index.vue'),
          name: '首页',
          meta: { title: '首页' }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/password',
      name: 'password',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import('@/views/password/index.vue'),
          name: '密码重置',
          meta: { title: '密码重置' }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/department',
      name: 'department',
      component: Layout,
      children: [
        {
          path: 'list',
          component: () => import('@/views/department/list.vue'),
          name: '部门管理',
          meta: { title: '部门管理' }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/supplier',
      name: 'supplier',
      component: Layout,
      children: [
        {
          path: 'list',
          component: () => import('@/views/supplier/list.vue'),
          name: '供应商管理',
          meta: { title: '供应商管理' }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/client',
      name: 'client',
      component: Layout,
      children: [
        {
          path: 'list',
          component: () => import('@/views/client/list.vue'),
          name: '客户管理',
          meta: { title: '客户管理' }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/material',
      name: 'material',
      component: Layout,
      children: [
        {
          path: 'list',
          component: () => import('@/views/material/list.vue'),
          name: '原料管理',
          meta: { title: '原料管理' }
        },
        {
          path: 'purchase',
          component: () => import('@/views/purchase/list.vue'),
          name: '采购记录',
          meta: { title: '采购记录' }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/goods',
      name: 'goods',
      component: Layout,
      children: [
        {
          path: 'list',
          component: () => import('@/views/goods/list.vue'),
          name: '商品管理',
          meta: { title: '商品管理' }
        },
        {
          path: 'classify',
          component: () => import('@/views/classify/list.vue'),
          name: '商品分类',
          meta: { title: '商品分类' }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/order',
      name: 'order',
      component: Layout,
      children: [
        {
          path: 'list',
          component: () => import('@/views/order/list.vue'),
          name: '订单管理',
          meta: { title: '订单管理' }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/menu',
      name: 'menu',
      component: Layout,
      children: [
        {
          path: 'list',
          component: () => import('@/views/menu/list.vue'),
          name: '菜单管理',
          meta: { title: '菜单管理' }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/right',
      name: 'right',
      component: Layout,
      children: [
        {
          path: 'list',
          component: () => import('@/views/right/list.vue'),
          name: '角色管理',
          meta: { title: '角色管理' }
        }
      ],
      meta: {
        hidden: true
      }
    },
    {
      path: '/404',
      name: '404',
      component: Layout,
      children: [
        {
          path: '/',
          component: () => import('@/views/Error/404.vue'),
          name: '404',
          meta: { title: '404' }
        }
      ],
      meta: {
        hidden: true
      }
    }
  ]

  export {
      routes,
      Layout
  }
